import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SeoMeta from "../../components/SeoMeta";
import PageTitle from "./components/PageTitle";
import PageBody from "./components/PageBody";
import { useLoading } from "../../contexts/LoadingContext";

// Get locale from cookie
const getLocale = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "en";
};

function Contact() {
  const { slug } = useParams();
  const [pageData, setPageData] = useState(null);
  const [error, setError] = useState(null);
  const { setIsLoading } = useLoading();

  const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337";
  const STRAPI_TOKEN = process.env.REACT_APP_STRAPI_TOKEN;
  const locale = getLocale();

  useEffect(() => {
    const fetchData = async () => {
      if (!STRAPI_URL) {
        setError("STRAPI_URL is not defined");
        setIsLoading(false);
        return;
      }

      const path = `/api/terms-of-use?locale=${locale}`;
      const url = new URL(STRAPI_URL + path);

      setIsLoading(true);
      try {
        if (!STRAPI_TOKEN) {
          throw new Error("Missing STRAPI_TOKEN in environment variables.");
        }

        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${STRAPI_TOKEN}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          const text = await response.text();
          throw new Error(`Fetch failed: ${response.status} - ${text}`);
        }

        const result = await response.json();
        setPageData(result.data || null);
      } catch (err) {
        console.error("❌ Fetch error:", err.message);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [slug, STRAPI_URL, STRAPI_TOKEN, locale, setIsLoading]);

  if (error) return <p>{error}</p>;
  if (!pageData) return null;

  const {
    title,
    publishedAt,
    body,
  } = pageData;

	
  return (
    <>
      <SeoMeta
        lang={locale}
        title={title}
        robots="noindex, nofollow"
      />
	  

      <section className="py-15 py-xl-20">
        <PageTitle
          title={title}
          subtitle={publishedAt}
        />

	  
        <PageBody
          body={body}
        />
	  
	  
      </section>
    </>
  );
}

export default Contact;
